<template>
  <el-row type="flex" justify="center" class="row-bg">
    <el-col :span="6">
      <el-image
        :src="list.img"
        style="width: 100%; height: 100%"
        fit="scale-down"
      >
        <div slot="error">
          <img src="../assets/00.jpeg" style="width: 100%; height: 100%" />
        </div>
      </el-image>
    </el-col>
    <el-col
      :span="6"
      style="background: #ffffff; border-radius: 1px solid #99a9bf"
    >
      <div class="right-conten">
        <div class="conten-top">
          <h5
            style="
              margin: 0;
              font-size: 20px;
              font-weight: bold;
              margin-bottom: 10px;
            "
          >
            {{ list.title }}
          </h5>
          <p style="margin-bottom: 10px">更新时间:{{ list.tm }}</p>
          <span>浏览量:{{ list.look_num }}</span>
          <div style="width: 100%; height: 1px; background: black"></div>
          <div class="main">
            <p>
              <span>报价:</span><span>{{ list.price }}</span>
            </p>
            <p>
              <span>发布人:</span><span>{{ list.peo }}</span>
            </p>
            <p>
              <span>手机号:</span><span>{{ list.phone }}</span>
            </p>
            <p>
              <span>所在地:</span><span>{{ list.addres }}</span>
            </p>
            <p>
              <span>产品介绍:</span><span>{{ list.con }}</span>
            </p>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      list: '',
    };
  },
  created() {
    this.httpList();
  },
  methods: {
    httpList() {
      const payload = {
        id: this.$route.query.id,
      };
      this.$axios
        .post('wb/index.php/Newicp/product_detail', payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
          },
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === 1) {
            this.list = res.data.info;
          } else {
            console.log(111);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.box-card {
  padding-top: 100px;
  display: flex;
  /* justify-content: space-between; */
}

.left-image,
.right-conten {
  flex: 1;
  /* border: 1px solid red; */
  margin: 0 10px;
  /* margin-left: 1%; */
}

.img-responsive {
  width: 100%;
  height: 500px;
  background: rgb(196, 194, 194);
  /* border: 1px solid saddlebrown; */
}

.conten-top {
  text-align: left;
  padding: 5px;
}

/* .line {
  width: 100%;
  height: 2px;
  background: black;
} */
.main p {
  margin-top: 30px;
}
.main p span {
  /* display: block; */
  padding: 0 5px;
}
.row-bg {
  margin-top: 100px;
  background-color: #ffff;
  height: 600px;
}
</style>
